import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import '../client.scss';
import NavBar from '../NavBar/NavbarLogin';
import Oval1 from 'assets/images/designs/Oval-1.png';
import Oval2 from 'assets/images/designs/Oval.png';
import { LanguageProvider, useLanguage } from '../../../../contexts/LanguageContext';
import Cookies from 'js-cookie';

// ✅ Clear
const ForgotPasswordContent = () => {
	const navigate = useNavigate();
	const [emailSendingStatus, setEmailSendingStatus] = useState('ENABLED');

	const [isMobile, setIsMobile] = useState(window.innerWidth < 650);
	
	const [email, setEmail] = useState('');
	const [login, setLogin] = useState(true);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const { t } = useLanguage();

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 650);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);


    const handleProcessEnter = (event) => {
        if (event.key === 'Enter') {
            onSubmit();
        }
	}
	
	const onSubmit = () => {

		// Email format validation
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			toast.error('Please enter a valid email address.');
			return;
		}


		const payload = {
			email: email
		};
		
		setIsSubmitting(true);

		if (emailSendingStatus === 'ENABLED') {

			toast.promise(api.forgotPasswordClient(payload), {
				loading: 'Sending OTP',
				success: (res) => {
					setIsSubmitting(false);
					if (res.status) {
						const { email, token } = res.data; // Extract email and token from res.data
						navigate('/client/forgot-password-otp', { state: { email, token } });
						return 'OTP sent successfully';
					} else {
						return 'Failed to process request';
					}
				},
				error: (err) => `Failed to process request: ${err.message}`
			});
		} else {
			toast.promise(api.forgotPasswordClientVerifyEmail(payload), {
				loading: 'Verifying email address',
				success: (res) => {
					if (res.status) {
						const { email, token } = res.data; // Extract email and token from res.data
						setIsSubmitting(false);
						if (email === undefined || token === undefined) {
							toast.error('This email address is not registered. Please check and try again.');
							return false;
						} else {
							navigate('/client/new-password', { state: { email, token } });
							return 'Email address verified successfully';

						}
					} else {
						return 'Failed to process request';
					}
				},
				error: (err) => `Failed to process request: ${err.message}`
			});
		}

	};
	
	
	useEffect(() => {
		api.checkEmailSendingStatus().then((res) => {
			if (res.status === true) {
				setEmailSendingStatus(res.data?.status);
			}
		});
	}, []);
	return (
		<>
			<div id="parent-client-wrapper">
				<div id="wrapper">
					<NavBar />

					<div
						id="new-wrapper"
						style={{
							fontFamily: 'Poppins, sans-serif'
						}}
					>
						<div id="content-wrapper" className="d-flex flex-column" style={{ backgroundColor: 'transparent' }}>
							<div id="content" style={{ position: 'relative' }}>
								<div className="container-fluid d-flex justify-content-center">
									<div style={{ maxWidth: '2200px', width: '100%', height: '90vh' }}>
										<div className={login ? 'main-page-auth-3' : 'main-page-auth-2'}>
											<div className={login ? 'backdrop-image-purple' : 'backdrop-image-purple-sign'}>
												<img src={Oval1} alt="Oval1" style={{ opacity: '50%' }} />
											</div>
											<div className={login ? 'backdrop-image-pink' : 'backdrop-image-pink-sign'}>
												<img src={Oval2} alt="Oval2" style={{ opacity: '70%' }} />
											</div>
											<div className="invoice-client-content">
												<div
													className="form-signup"
													style={{ justifyContent: 'space-between' }}
													onKeyPress={(event) => {
														if (event.key === 'Enter') {
															event.preventDefault();
														}
													}}
												>
													<div className="signup-head" style={{ marginBottom: 20 }}>
														<h4 style={{ marginBottom: 5 }}>{t('client.password-reset.title')}</h4>
													</div>
													<div className="row" style={{ marginBottom: 20 }}>
														<div className={isMobile ? 'col-12' : 'col-12'}>
															<input
																type="text"
																className="form-control"
																placeholder="Email@gmail.com"
																style={{ color: 'black', borderColor: '#0066FF' }}
																autocomplete="nope"
																onChange={(e) => {
																	setEmail(e.target.value);
																}}
																onKeyDown={handleProcessEnter}
															/>
														</div>
													</div>
													<div className="action-signup">
														<button
															className="btn btn-cmpny-dtls-action"
															type="submit"
															onClick={() => onSubmit()}
															disabled={isSubmitting} // Disable the button when isSubmitting is true
														>
															{
																emailSendingStatus === 'ENABLED' ? ( 
																	t('client.password-reset.send-otp')
																) : (
																	'Verify Email'
																)
															}
														</button>
													</div>
												</div>
											</div>
										</div>
										<div
											style={{
												position: 'fixed',
												bottom: 20,
												left: '50%',
												transform: 'translate(-50%, 0)',
												textAlign: 'center'
											}}
										>
											{t('client.@-year-project')} <span style={{ display: 'inline-block' }}>{t('client.@-all-rights-reserved')}</span>

										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Toaster
				toastOptions={{
					className: 'toaster-styles-2'
				}}
			/>
		</>
	);
};

const ForgotPassword = () => {
	const getInitialLocale = () => {
		const localeCookie = Cookies.get('locale');
		if (['en', 'nl', 'es', 'it', 'ae'].includes(localeCookie)) {
			return localeCookie;
		}
		return 'en';
	};

	const initialLocale = getInitialLocale();

	return (
		<LanguageProvider initialLocale={initialLocale}>
			<ForgotPasswordContent />
		</LanguageProvider>
	);
};

export default ForgotPassword;
